export default __webpack_public_path__ + "static/media/swap-background.7bf16cf7.png";